import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { ObjectDetailCard } from '../../../v2/components/generic/ObjectView/ObjectDetailCard';
import { getViewDefinitionFromUserAttributes } from '../../factories/AttributeDefinitions';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ObjectDetailCardWidget = (props) => {
    const [viewDefinition, setViewDefinition] = useState();
    useEffect(() => {
        if (props.user && !viewDefinition) {
            const attributes = props.user.getUserAttributes();
            const viewDefinition = getViewDefinitionFromUserAttributes(attributes);
            setViewDefinition(viewDefinition);
        }
    }, [props.user]);
    const component = useMemo(() => props.user && viewDefinition ? (_jsx(ObjectDetailCard, { matchedPrimary: props.user, mostProximateCustomer: undefined, transactionFunctions: props.transactionFunctions, userFunctions: props.userFunctions })) : (_jsx(_Fragment, {})), [props.user, viewDefinition]);
    return {
        name: 'ObjectDetailCard',
        category: 'composite',
        component,
    };
};
